import React from "react"
import "./styles.scss"
import Apollo from "../../svg/Apollo"
import Jager from "../../svg/Jager"
import Huddly from "../../svg/Huddly"
import Explorers from "../../svg/Explorers"

const Clients = () => {
  return (
    <section className="section section--clients">
      <div className="wrapper">
        <div className="clients">
          <div className="clients__client">
            <Apollo />
          </div>

          <div className="clients__client">
            <Jager />
          </div>

          <div className="clients__client">
            <Explorers />
          </div>

          <div className="clients__client">
            <Huddly />
          </div>
        </div>
      </div>
    </section>
  )
}

export default Clients
